import { Controller } from "@hotwired/stimulus";
import { makeMatcher } from "../utils/text_match";

// Tracker — left panel: filterable user list ; right panel: AJAX-loaded
// detail of the selected user. The detail HTML comes back from
// `parcours#lesson_progresses` (existing endpoint, returns a partial).
export default class extends Controller {
  static targets = ["search", "userRow", "detail"];
  static values  = { juniorId: String, parcourId: String };

  search(event) {
    // Recherche par mots : « Olivia Bironneau » retrouve « BIRONNEAU Olivia ».
    const matcher = makeMatcher(event.target.value);
    this.userRowTargets.forEach((row) => {
      row.hidden = !matcher(row.dataset.searchHaystack || "");
    });
  }

  async showDetail(event) {
    const row = event.currentTarget;
    const userId = row.dataset.userId;
    if (!userId || !this.hasDetailTarget) return;

    this.userRowTargets.forEach((r) => r.classList.toggle("is-active", r === row));
    this.detailTarget.innerHTML = `
      <div class="lc-tracker__detail-empty">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <p>Chargement…</p>
      </div>`;

    try {
      const url = `/juniors/${this.juniorIdValue}/parcours/${userId}/lesson_progresses?parcour_id=${this.parcourIdValue}`;
      const response = await fetch(url, {
        headers: { Accept: "text/html" },
        credentials: "same-origin"
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = await response.text();
      this.detailTarget.innerHTML = html;
    } catch (_e) {
      this.detailTarget.innerHTML = `
        <div class="lc-tracker__detail-empty">
          <i class="fa-solid fa-triangle-exclamation"></i>
          <h3>Impossible de charger les détails</h3>
          <p>Vérifie ta connexion et réessaie.</p>
        </div>`;
    }
  }
}
